import styled from "styled-components";

export const StyledBodyAdminComment = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledMessageChipWrapper = styled.div`
  width: fit-content;
`;

export const StyledDevelopmentCommentWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey_8};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

export const StyledSendCommentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledWrapperCommentInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: flex-end;
`;
